import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "@nuxtjs/composition-api";

enum MessageTypes {
    INFO = "info",
    DANGER = "danger",
}

interface Props {
    text?: string;
    type?: 'info' | 'danger';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoMessage',
  props: {
    text: null,
    type: { default: "info" }
  },
  setup(__props: any) {

const props = __props as { text?: string, type: 'info' | 'danger' };



const {
    text,
    type,
} = toRefs(props);

const infoMessageColor = computed(() => {
    switch (type.value) {
        case MessageTypes.INFO:
            return 'primary-icons-primary'
        case MessageTypes.DANGER:
            return 'error-notifications-icons-error-notifications'
    }
})

return { __sfc: true,MessageTypes, props, text, type, infoMessageColor }
}

})